import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";


import { AuthContext } from "../../contexts/auth";
import { useNavigate, useParams } from "react-router-dom";

import { permite_acesso, pagamentos_pix, pagamentos_credito } from "../../services/api";

import { set, useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Table from "react-bootstrap/Table";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/esm/Col";

import Accordion from 'react-bootstrap/Accordion';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import InputGroup from 'react-bootstrap/InputGroup';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Nav from 'react-bootstrap/Nav';

import TabelaPagamentosMol from "./Tabela_Pagamentos_Mol.jsx";

const schema = yup.object({}).required();

const Tesouraria = () => {

    let { cod_unidade } = useParams();



    const perfil = JSON.parse(localStorage.getItem("perfil"));
    const usuario = JSON.parse(localStorage.getItem("user"));
    const token = localStorage.getItem("token");

    const { authenticated, logout } = useContext(AuthContext);
    const navigate = useNavigate();
    const [acesso, setAcesso] = useState(false);
    const [dataInicio, setDataInicio] = useState('2024-08-31');

    const amanha = new Date();
    amanha.setDate(amanha.getDate() + 1);
    const novaDataFim = amanha.toISOString().split('T')[0];
    const [dataFim, setDataFim] = useState(novaDataFim);

    const [status, setStatus] = useState('APPROVED');

    const [dataPix, setDataPix] = useState([]);
    const [dataCC, setDataCC] = useState([]);


    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes']

    const {
        register,
        setValue,
        handleSubmit,
        setFocus,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });

    const fetchData = async () => {
        try {
            const resultado2 = await pagamentos_credito(dataInicio, dataFim, status);
            console.log('resultado2', resultado2)
            setDataCC(resultado2);
            const resultado3 = await pagamentos_pix(dataInicio, dataFim, status);
            setDataPix(resultado3);

        } catch (error) {
            console.error(error);
        }
    };


    useEffect(() => {
        (async () => {

            fetchData();

        })();
    }, [dataInicio, dataFim, status]);

    const handleData = (e) => {
        e.preventDefault();
        let dti = document.querySelector(
            "input[name = inicio]"
        ).value;
        console.log(dti);
        setDataInicio(dti);
        let dtf = document.querySelector(
            "input[name = fim]"
        ).value;
        console.log(dtf);
        setDataFim(dtf);

    };

    const handleStatus = (e) => {
        e.preventDefault();
        if (status === "APPROVED") {
            setStatus("ALL");
        } else {
            setStatus("APPROVED");
        }
    };

    let conta_pix = 0;
    let conta_cc = 0;

    const Experiment = (Nperfil) => {
        if (Nperfil === "GESTOR")
            return (
                <>
                    <NavDropdown.Item href="/unidade/10">Barra da Tijuca</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/01">Bento Ribeiro</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/11">Campo Grande</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/04">Cascadura</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/16">Freguesia</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/15">Ilha do Governador</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/02">Madureira</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/14">Maricá</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/06">Nilópolis</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/17">Recreio</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/03">Santa Cruz</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/09">Seropédica</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/05">Taquara</NavDropdown.Item>
                    <NavDropdown.Item href="/tesouraria">Tesouraria - Pagamentos</NavDropdown.Item>
                </>
            );
        if (Nperfil.startsWith("DIRETOR")) {
            var numerosString = Nperfil.replace("DIRETOR", "").trim();
            var numerosArray = numerosString.split("-");
            var codigoDinamico = numerosArray.map(function (cod_unidade) {
                return (
                    <NavDropdown.Item href={`/unidade/${cod_unidade}`}>
                        {unidades[parseInt(cod_unidade)]}
                    </NavDropdown.Item>
                );
            });
            <NavDropdown.Item href="/tesouraria">Tesouraria - Pagamentos</NavDropdown.Item>
            return (codigoDinamico)


        };
        if (Nperfil.startsWith("SECRETARIA")) {
            var numerosString = Nperfil.replace("SECRETARIA", "").trim();
            var numerosArray = numerosString.split("-");
            var codigoDinamico = numerosArray.map(function (cod_unidade) {
                return (
                    <NavDropdown.Item href={`/unidade/${cod_unidade}`}>
                        {unidades[parseInt(cod_unidade)]}
                    </NavDropdown.Item>
                );
            });
            <NavDropdown.Item href="/tesouraria">Tesouraria - Pagamentos</NavDropdown.Item>
            return (codigoDinamico)
        };

    }

    let chartDataPix = [];
    if (typeof dataPix !== 'undefined') {
        chartDataPix = dataPix.map((item, index) => {
            conta_pix++;

            const row = [unidades[parseInt(item.customer_id.slice(0, 2))]]
            row.push(item.customer_id);
            row.push(item.transaction_id);
            let valor = parseFloat(item.amount) / 100;
            row.push(valor);

            const timestampOriginal = new Date(item.transaction_timestamp);
            timestampOriginal.setHours(timestampOriginal.getHours() - 3);
            let timestamp = timestampOriginal.toISOString();
            timestamp = timestamp.replace("T", " ");
            timestamp = timestamp.replace(".000Z", " ");
            row.push(timestamp);

            row.push(item.status);
            return row;
        });

    };

    chartDataPix.unshift(['UNIDADE', 'MATRICULA', 'TRANSATION_ID', 'VALOR', 'HORARIO', 'STATUS']);

    let chartDataCC = [];

    console.log('dataCC', dataCC)

    if (typeof dataCC !== 'undefined') {
        chartDataCC = dataCC.map((item, index) => {
            conta_cc++;
            const row = [unidades[parseInt(item.customer_id.slice(0, 2))]]
            row.push(item.customer_id);
            row.push(item.acquirer_transaction_id);
            let valor = parseFloat(item.amount) / 100;
            row.push(valor);
            row.push(item.number_installments);

            const timestampOriginal = new Date(item.authorization_timestamp);
            timestampOriginal.setHours(timestampOriginal.getHours() - 3);
            let timestamp = timestampOriginal.toISOString();
            timestamp = timestamp.replace("T", " ");
            timestamp = timestamp.replace(".000Z", " ");
            row.push(timestamp);

            row.push(item.status);
            return row;
        });

    };

    chartDataCC.unshift(['UNIDADE', 'MATRICULA', 'TRANSATION_ID', 'VALOR', 'PARCELAS', 'HORARIO', 'STATUS']);

    console.log('chartDataCC', chartDataCC)

    const options = {
        allowHtml: true,

    };

    let formatters = [
        {
            type: "NumberFormat",
            column: 2,
            options: {
                prefix: "R$ ",
                negativeColor: "red",
                negativeParens: true,
            },
        },

    ];



    return (
        <div className="Tesouraria">

            <Navbar sticky="top" className="bg-body-tertiary">
                <Nav.Link href="/">Santa Mônica Rede de Ensino</Nav.Link>
                <NavDropdown
                    title="UNIDADES"
                >
                    {Experiment(perfil[0].perfil)}

                </NavDropdown>

                <Row>
                    <Form onSubmit={handleData}>

                        <Row>
                            <Col xs="auto">
                                <InputGroup>
                                    <InputGroup.Text id="basic-addon1">Data Início</InputGroup.Text>
                                    <Form.Group >
                                        {/* <Form.Label >Data Início: </Form.Label> */}
                                        <Form.Control
                                            name="inicio"
                                            type="date"
                                            placeholder={dataInicio}
                                            label="Data Início:"
                                            className=" mr-sm-2" >

                                        </Form.Control>
                                    </Form.Group>
                                </InputGroup>

                            </Col>
                            <Col xs="auto">
                                <InputGroup>
                                    <InputGroup.Text id="basic-addon1">Data Fim</InputGroup.Text>
                                    <Form.Group >
                                        {/* <Form.Label htmlFor="floatingInput" >Data Início: </Form.Label> */}
                                        <Form.Control
                                            name="fim"
                                            type="date"
                                            placeholder={dataFim}
                                            label="Data Fim:"
                                            className=" mr-sm-2" >
                                        </Form.Control>
                                    </Form.Group>
                                </InputGroup>

                            </Col>
                            <Col xs="auto">
                                <Button variant="primary" type="submit">
                                    Filtrar datas
                                </Button>
                            </Col>
                            <Col xs="auto">
                                <Button variant="primary" onClick={handleStatus}> {status} </Button>
                            </Col>
                            <Col xs="auto">
                                <Button variant="primary" onClick={(e) => { navigate("\login") }} > Sair  </Button>
                            </Col>


                        </Row>


                    </Form>
                </Row>

            </Navbar>

            <Container>
                <div className="media">
                    <h2>
                        Pagamentos em Pix: {conta_pix} de {conta_pix + conta_cc} matriculas online

                    </h2>
                    <Chart
                        chartType="Table"
                        width="100%"
                        version="current"

                        data={chartDataPix}
                        options={options}
                        formatters={formatters}
                        chartWrapperParams={{ view: { columns: [0, 1, 2, 3, 4, 5] } }}
                        chartPackages={["corechart", "controls"]}
                        controls={[
                            {
                                controlEvents: [
                                    {
                                        eventName: "statechange",
                                        callback: ({ chartWrapper, controlWrapper }) => {
                                            console.log("State changed to", controlWrapper?.getState());
                                        },
                                    },
                                ],
                                controlType: "CategoryFilter",
                                options: {
                                    filterColumnIndex: 0,
                                    ui: {
                                        labelStacking: "vertical",
                                        label: "UNIDADE",
                                        allowTyping: false,
                                        allowMultiple: false,
                                    },
                                },
                            },
                        ]}
                    />
                    {/* <Chart
                        chartType="Table"
                        width="100%"
                        data={chartDataPix}
                        options={options}
                        formatters={formatters}
                    /> */}
                </div>
                <br />
                <div className="media">
                    <h2>
                        Pagamentos em Cartão de Crédito: {conta_cc} de  {conta_pix + conta_cc}  matriculas online


                    </h2>
                    <Chart
                        chartType="Table"
                        width="100%"
                        version="current"

                        data={chartDataCC}
                        options={options}
                        formatters={formatters}
                        chartWrapperParams={{ view: { columns: [0, 1, 2, 3, 4, 5, 6] } }}
                        chartPackages={["corechart", "controls"]}
                        controls={[
                            {
                                controlEvents: [
                                    {
                                        eventName: "statechange",
                                        callback: ({ chartWrapper, controlWrapper }) => {
                                            console.log("State changed to", controlWrapper?.getState());
                                        },
                                    },
                                ],
                                controlType: "CategoryFilter",
                                options: {
                                    filterColumnIndex: 0,
                                    ui: {
                                        labelStacking: "vertical",
                                        label: "UNIDADE",
                                        allowTyping: false,
                                        allowMultiple: false,
                                    },
                                },
                            },
                        ]}
                    />
                    {/* <Chart
                        chartType="Table"
                        width="100%"
                        data={chartDataCC}
                        options={options}
                        formatters={formatters}
                    /> */}
                </div>
                <div className="mt-4">
                    <TabelaPagamentosMol />
                </div>
            </Container>

        </div>
    );
};

export default Tesouraria;